import { PhoneOutlineIcon } from './PhoneOutlineIcon';

/**
 * author: Google
 * id 79252282-1FDF-4DE8-A00F-51CD9D23311D
 * name phone-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneOutlineIcon = PhoneOutlineIcon;
export default TelephoneOutlineIcon